

export enum ExecutionStatus{
    Pending = "Pending",
    Finished = "Finished",
    Failed = "Failed"
}

export interface GeneralResponse {
    clientSyncId: string;
    executionStatus: ExecutionStatus;
}

export interface GeneralRequest {
    //clientSyncId: string;
}

